import { Route } from 'types/route.type';
import ListOrderSupplyPlan from 'views/playground/features/my-supply-plan/components/my-supply-plan';

export const routes: Route[] = [
  {
    path: '/playground/supply-plan/:siteErpId?/:globalSiteId?',
    component: ListOrderSupplyPlan,
    id: 'orderFeed.navigation.orderSupplyPlan',
  },
];
